/**
 * Central location for GraphQL filter definitions
 * Used across multiple hooks for querying regulation-related data
 */

export const createRegulationIdFilter = (regulationId: string) => ({
  groupKey: 'REGULATION_ID',
  filterValues: [{ value: regulationId }],
});

export const createObligationIdFilter = (obligationId: string) => ({
  groupKey: 'REGULATION_OBLIGATION_ID',
  filterValues: [{ value: obligationId }],
});

export const createDocumentInstanceIdFilter = (documentInstanceId: string) => ({
  groupKey: 'REGULATION_DOCUMENT_INSTANCE_ID',
  filterValues: [{ value: documentInstanceId }],
});

export const createObligationReviewStatusFilter = (
  reviewStatus: string,
  groupKey: 'REGULATION_OBLIGATION_REVIEW_STATUS' | 'REGULATION_OBLIGATION_MAPPINGS_REVIEW_STATUS',
) => ({
  groupKey,
  filterValues: [{ value: reviewStatus }],
});
